import { render, staticRenderFns } from "./data-comparison.vue?vue&type=template&id=08938daa&scoped=true&"
import script from "./data-comparison.vue?vue&type=script&lang=js&"
export * from "./data-comparison.vue?vue&type=script&lang=js&"
import style0 from "./data-comparison.vue?vue&type=style&index=0&id=08938daa&prod&scoped=true&lang=scss&"
import style1 from "./data-comparison.vue?vue&type=style&index=1&id=08938daa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08938daa",
  null
  
)

export default component.exports